// extracted by mini-css-extract-plugin
module.exports = {"wrap":"page_loader_wrap__3OcWY","text":"page_loader_text__2RcC1","bounceball":"page_loader_bounceball__3FBdR","bounce":"page_loader_bounce__XVWDJ"};